// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instrument-form {
    list-style: none;
    margin: 0 auto;
    padding: 1rem;
    width: 90%;
    max-width: 40rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    border-radius: 6px;
    background: white
}

.instrument-form__heading {
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
}

.instrument-form .button-group {
    display: flex;
    justify-content: center; /* Center aligns the buttons horizontally */
    padding: 10px; /* Adds padding around the buttons */
    gap: 10px; /* Space between the two buttons */
}`, "",{"version":3,"sources":["webpack://./src/dashboard/pages/NewInstrument.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,2CAA2C;IACpE,aAAa,EAAE,oCAAoC;IACnD,SAAS,EAAE,kCAAkC;AACjD","sourcesContent":[".instrument-form {\n    list-style: none;\n    margin: 0 auto;\n    padding: 1rem;\n    width: 90%;\n    max-width: 40rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n    border-radius: 6px;\n    background: white\n}\n\n.instrument-form__heading {\n    margin: 0 0 0.5rem;\n    font-size: 1.1rem;\n}\n\n.instrument-form .button-group {\n    display: flex;\n    justify-content: center; /* Center aligns the buttons horizontally */\n    padding: 10px; /* Adds padding around the buttons */\n    gap: 10px; /* Space between the two buttons */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
